"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = require("../../../Button");
const functions_1 = require("../../utils/functions");
require("./date-value.scss");
const DateValue = (_a) => {
    var { value, type, date, style, disabledArrow, onChangeDate } = _a, rest = __rest(_a, ["value", "type", "date", "style", "disabledArrow", "onChangeDate"]);
    const [currentValue, setCurrentValue] = (0, react_1.useState)("");
    const [currentDate, setCurrentDate] = (0, react_1.useState)();
    const directionRef = (0, react_1.useRef)();
    const valueElementRef = (0, react_1.useRef)(null);
    const dateValueClasses = (0, classnames_1.default)("date-value", type);
    (0, react_1.useLayoutEffect)(() => {
        if ((valueElementRef === null || valueElementRef === void 0 ? void 0 : valueElementRef.current) && currentDate && currentDate !== date) {
            (0, functions_1.animateDateChange)(type, date, currentDate, valueElementRef.current, setCurrentValue);
        }
        if (currentValue === "") {
            setCurrentValue(date.toFormat((0, functions_1.getFormatDateByDateType)(type)));
        }
        setCurrentDate(date);
    }, [value]);
    const handleOnChangeDate = (dateType, direction) => {
        directionRef.current = direction;
        onChangeDate(dateType, direction);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: dateValueClasses, style: style }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${type} inner-value`, ref: valueElementRef }, rest, { children: currentValue })) })), ["month", "year"].includes(type) && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "date-value-arrows" }, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { "data-testid": `${rest["data-testid"]}-buttonUp`, size: "extra-small", disabled: ((disabledArrow === null || disabledArrow === void 0 ? void 0 : disabledArrow.length) && disabledArrow.includes("up")) || false, className: "date-value-arrow", iconName: "arrow-up", onClick: () => {
                            handleOnChangeDate(type, "up");
                        } }), (0, jsx_runtime_1.jsx)(Button_1.Button, { "data-testid": `${rest["data-testid"]}-buttonDown`, size: "extra-small", disabled: ((disabledArrow === null || disabledArrow === void 0 ? void 0 : disabledArrow.length) && disabledArrow.includes("down")) || false, className: "date-value-arrow", iconName: "arrow-down", onClick: () => {
                            handleOnChangeDate(type, "down");
                        } })] })))] }));
};
DateValue.defaultProps = { style: {}, disabledArrow: undefined };
exports.default = DateValue;
